export default __webpack_public_path__ + "static/media/Pagamento.68896e3a.svg";